/* global moment */
(function () {
  'use strict';

  angular.module('wsLrs.services').factory('MomentInterface', ['Utils', function (Utils) {
    var assignMethods = Utils.assignMethods;

    // moment methods
    var validate = function validate(x) {
      return moment(x).isValid();
    };
    var toDate = function toDate(x) {
      return moment(x).toDate();
    };
    var utc = function utc(x) {
      return moment.utc(x);
    };
    var utcToDate = function utcToDate(x, format) {
      return moment.utc(x, format).toDate();
    };
    var duration = function duration(t, unit) {
      return moment.duration(t, unit);
    };
    return assignMethods({}, [['validate', validate], ['toDate', toDate], ['utc', utc], ['utcToDate', utcToDate], ['duration', duration]]);
  }]);
})();
